var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"self-center"},[_c('img',{staticClass:"image-size",attrs:{"src":_vm.params.banner_image
        ? _vm.params.banner_image
        : require('@/assets/images/placeholder/no-image.jpg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }